<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  export default {
    name: 'FallbackAvatar',
    props: {
      size: String,
      rounded: {
        type: String || Number || Boolean,
        default: 'circle',
      },
      iconSize: String,
      styleClass: String,
    },
  }
</script>
